/* Linden — the quantity stepper.

   This lives in an asset rather than in the snippet's {% javascript %} block,
   and the distinction is not cosmetic. Shopify bundles a snippet's script only
   when that snippet is rendered in the initial response. The cart drawer on a
   page loaded with an empty cart renders its empty state, which contains no
   stepper — so the class was never defined on that page. Adding a product then
   brought fresh drawer markup through the section rendering API, complete with
   stepper buttons that no code had ever been taught to answer. Press + or −,
   nothing happens, no error anywhere.

   Behaviour has to be available before the markup that needs it can arrive.
   side-drawer was always in an asset, which is why the drawer itself kept
   working while the controls inside it did not. */

class QuantitySelector extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.quantity__input');
    if (!this.input) return;

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-change]');
      if (!button) return;

      const step = Number(button.dataset.quantityChange);
      const min = Number(this.input.min || 1);
      const max = QuantitySelector.ceiling(this.input);
      const next = Math.min(max, Math.max(min, Number(this.input.value) + step));

      if (next !== Number(this.input.value)) {
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.refresh();
    });

    this.input.addEventListener('change', () => this.refresh());
    this.refresh();
  }

  /* The string "0" is truthy in JavaScript, so a stray max="0" would read as a
     ceiling of zero and disable the plus button at any quantity. Anything that
     is not a positive number means no ceiling. */
  static ceiling(input) {
    const raw = Number(input.max);
    return Number.isFinite(raw) && raw > 0 ? raw : Infinity;
  }

  refresh() {
    const min = Number(this.input.min || 1);
    const max = QuantitySelector.ceiling(this.input);
    const value = Number(this.input.value);

    this.querySelectorAll('[data-quantity-change]').forEach((button) => {
      const step = Number(button.dataset.quantityChange);
      button.disabled = step < 0 ? value <= min : value >= max;
    });
  }
}

if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}
